import {useLocation} from 'react-router-dom';
import {Grid, Header, Loader, Message, Container} from 'semantic-ui-react';

import {useHttpClient} from 'hooks';

import SearchBar from '../SearchBar/SearchBar';
import SearchTable from '../SearchTable/SearchTable';

import styles from './SearchPage.module.scss';

const renderSites = (sites, error, query) => {
  if (error) {
    return <Message negative>{error}</Message>;
  }

  if (sites.length === 0) {
    return (
      <Header as="h4" color="grey">
        No matching sites
      </Header>
    );
  }

  return <SearchTable sites={sites} query={query} />;
};

const SearchPage = () => {
  const query = new URLSearchParams(useLocation().search).get('q');

  const {data: sites, error, loading: isLoadingSites} = useHttpClient({
    url: `/api/search/hostnames`,
    method: 'GET',
    params: {q: query},
  });

  return (
    <Grid centered className={styles.SearchPage}>
      <Header as="h1">Search</Header>
      <Grid.Row>
        <Container>
          <SearchBar className={styles.SearchBar} />
        </Container>
      </Grid.Row>
      <Grid.Row>
        {isLoadingSites ? (
          <Loader className={styles.SearchLoader} active>
            Loading...
          </Loader>
        ) : (
          renderSites(sites, error, query)
        )}
      </Grid.Row>
    </Grid>
  );
};

export default SearchPage;
